import styled, { css } from 'styled-components';

export const Screen = styled.main(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    height: 100vh;
    height: 100dvh;
    min-height: 0;
    overflow: hidden;
    background-color: ${theme.co.blobBackground};
  `,
);

export const HeaderSlot = styled.div`
  flex-shrink: 0;
`;

export const ScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior-y: contain;
`;

export const Content = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.sz.s12};
    width: 100%;
    max-width: ${theme.sz.md};
    margin: 0 auto;
    padding: ${theme.sz.s8} ${theme.sz.s4} ${theme.sz.s6};

    @media (max-width: ${theme.sz.md}) {
      gap: ${theme.sz.s4};
      padding: 0 ${theme.sz.s4} ${theme.sz.s4};
    }
  `,
);

export const Hero = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    align-self: stretch;
    gap: ${theme.sz.s5};

    @media (max-width: ${theme.sz.md}) {
      gap: ${theme.sz.s3};
    }
  `,
);

export const HeroText = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
`;

export const TitleRow = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.sz.s1};
    min-width: 0;
  `,
);

export const Title = styled.h1(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.accent.xxl};
    margin: 0;
    color: ${theme.co.neutral10};
    overflow-wrap: break-word;

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.heading.mobile.accent.xl};
    }
  `,
);

export const TranslationHint = styled.div(
  ({ theme }) => css`
    flex-shrink: 0;
    color: ${theme.co.neutral30};
    font-size: ${theme.sz.s5};
    line-height: 1;

    button {
      margin-left: 0;
      font-size: inherit;
    }
  `,
);

export const Subheader = styled.p(
  ({ theme }) => css`
    ${theme.typography.paragraph.base};
    margin: 0;
    color: ${theme.co.neutral30};

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.m};
    }
  `,
);

export const Groups = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s4};
    width: 100%;

    @media (max-width: ${theme.sz.md}) {
      gap: ${theme.sz.s3};
    }
  `,
);

export const Results = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s6};
    width: 100%;

    @media (max-width: ${theme.sz.md}) {
      gap: ${theme.sz.s4};
    }
  `,
);

export const Footer = styled.div(
  ({ theme }) => css`
    position: sticky;
    bottom: 0;
    display: flex;
    flex-shrink: 0;
    justify-content: center;
    padding: ${theme.sz.s4} ${theme.sz.s4} calc(${theme.sz.s4} + env(safe-area-inset-bottom, 0px));
    border-top: ${theme.bo.thinWidth} solid ${theme.co.primary90};
    background-color: ${theme.co.blobBackground};
  `,
);
